
import api from "../api";



const verifyToken = async () => {
  try {
    const response = await api.get(process.env.REACT_APP_API_ENDPOINT + "/api/user/verifyToken");

    return response.data;

  } catch (error) {

    console.error(error)
    return error;
  }
}; // Removed requestData from dependencies


export default verifyToken;
